import {
  CDK_ROW_TEMPLATE,
  CdkFooterRow,
  CdkFooterRowDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkNoDataRow,
  CdkRow,
  CdkRowDef
} from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, Directive, HostBinding, ViewEncapsulation } from '@angular/core';

/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */

/* eslint-disable @typescript-eslint/naming-convention */


/**
 * Header row definition for the mui-table.
 */
@Directive({
  selector: '[muiHeaderRowDef]',
  providers: [{ provide: CdkHeaderRowDef, useExisting: MuiHeaderRowDef }],
  inputs: [
    // Use the same inputs as CdkHeaderRowDef, but rename them to match the MUI table.
    'sticky: muiHeaderRowDefSticky',
    'columns: muiHeaderRowDefColumns'
  ]
})
export class MuiHeaderRowDef extends CdkHeaderRowDef {}

/**
 * Footer row definition for the mui-table.
 */
@Directive({
  selector: '[muiFooterRowDef]',
  providers: [{ provide: CdkFooterRowDef, useExisting: MuiFooterRowDef }],
  inputs: [
    // Use the same inputs as CdkHeaderRowDef, but rename them to match the MUI table.
    'sticky: muiFooterRowDefSticky',
    'columns: muiFooterRowDefColumns'
  ]
})
export class MuiFooterRowDef extends CdkFooterRowDef {}

/**
 * Data row definition for the mui-table.
 */
@Directive({
  selector: '[muiRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: MuiRowDef }],
  inputs: [
    // Use the same inputs as CdkHeaderRowDef, but rename them to match the MUI table.
    'when: muiRowDefWhen',
    'columns: muiRowDefColumns'
  ]
})
export class MuiRowDef<T> extends CdkRowDef<T> {}

/** Footer template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'mui-header-row, tr[mui-header-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'muiHeaderRow',
  providers: [{ provide: CdkHeaderRow, useExisting: MuiHeaderRow }]
})
export class MuiHeaderRow extends CdkHeaderRow {
  @HostBinding('class.mui-table__header-row') baseClass = true;
  @HostBinding('attr.role') role = 'row';
}

/** Footer template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'mui-footer-row, tr[mui-footer-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'muiFooterRow',
  providers: [{ provide: CdkFooterRow, useExisting: MuiFooterRow }]
})
export class MuiFooterRow extends CdkFooterRow {
  @HostBinding('class.mui-footer-row') baseClass = true;
  @HostBinding('attr.role') role = 'row';
}

/** Data row template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'mui-row, tr[mui-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'muiRow',
  providers: [{ provide: CdkRow, useExisting: MuiRow }]
})
export class MuiRow extends CdkRow {
  @HostBinding('class.mui-row') baseClass = true;
  @HostBinding('attr.role') role = 'row';
}

/** Row that can be used to display a message when no data is shown in the table. */
@Directive({
  selector: 'ng-template[muiNoDataRow]',
  providers: [{ provide: CdkNoDataRow, useExisting: MuiNoDataRow }]
})
export class MuiNoDataRow extends CdkNoDataRow {
  override _contentClassName = 'mui-row--no-data';
}
